export default __webpack_public_path__ + "static/media/V346_RoHS.3aca06a8.pdf";